export default function ProcessSteps() {
  const steps = [
    {
      number: '01',
      icon: 'ri-chat-quote-line',
      title: 'Advies & Offerte',
      description:
        'We bespreken uw wensen, meten op en adviseren over de beste vloer. Binnen 24 uur ontvangt u een gedetailleerde offerte inclusief materiaal en leggen.',
    },
    {
      number: '02',
      icon: 'ri-calendar-check-line',
      title: 'Planning & Voorbereiding',
      description:
        'Na akkoord plannen we direct de installatie. Wij regelen materialen, ondervloer en alle voorbereidend werk.',
    },
    {
      number: '03',
      icon: 'ri-tools-line',
      title: 'Professionele Installatie',
      description:
        'Onze ervaren leggers voeren de werkzaamheden uit met precisie. Inclusief afvoer oude vloer, egalisatie en perfecte eindafwerking.',
    },
    {
      number: '04',
      icon: 'ri-shield-check-line',
      title: 'Garantie & Nazorg',
      description:
        'Geniet met volledige garantie. We blijven beschikbaar voor vragen en ondersteuning. Uw tevredenheid is onze prioriteit.',
    },
  ];

  return (
    <section id="proces" className="py-20 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-20">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-ink-900 mb-3 sm:mb-4">
            Uw PVC vloer professioneel gelegd in{' '}
            <span className="font-medium text-brass-600">4 stappen</span>
          </h2>
          <p className="text-base sm:text-lg text-ink-600 max-w-2xl mx-auto">
            Van eerste contact tot uw prachtige nieuwe vloer
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {steps.map((step, i) => (
            <div key={i} className="relative group">
              {/* Connector line */}
              {i < 3 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-gradient-to-r from-brass-200 to-transparent -translate-x-4"></div>
              )}

              <div className="relative bg-cream-50 rounded-2xl p-6 sm:p-8 h-full transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
                <div className="absolute -top-3 sm:-top-4 -left-3 sm:-left-4 w-10 h-10 sm:w-12 sm:h-12 bg-brass-500 text-white rounded-full flex items-center justify-center font-bold text-base sm:text-lg shadow-lg">
                  {step.number}
                </div>

                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-xl flex items-center justify-center mb-5 sm:mb-6 group-hover:scale-110 transition-transform duration-300 shadow-sm">
                  <i className={`${step.icon} text-2xl sm:text-3xl text-brass-600`}></i>
                </div>

                <h3 className="text-lg sm:text-xl font-semibold text-ink-900 mb-3 sm:mb-4">{step.title}</h3>
                <p className="text-sm sm:text-base text-ink-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 sm:mt-16">
          <a
            href="#offerte"
            className="inline-flex items-center gap-2 bg-brass-500 hover:bg-brass-600 text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg font-medium transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            Start Jouw Vloer
            <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}